import axios from 'axios'
import { getJwtToken, getXApiKey } from '../lib/cookieUtils'
 
const apiURL = process.env.REACT_APP_MESSAGING_API
const jobseekerApiURL = process.env.REACT_APP_CONNECTIONS_API
const connectionsXApiKey = process.env.REACT_APP_CONNECTIONS_X_API_KEY
const coreApiURL = process.env.REACT_APP_CORE_API
export const environment = process.env.REACT_APP_ENV
const JT_TOKEN = 'jtToken'

let _jwtToken = ''
export const setAxiosToken = (token: string) => { _jwtToken = token }

/* TJSKR-1967: Helper function to get JT Token from cookies */
// const getCookieValue = (name: string): string | null => {
//   const cookies = document.cookie.split('; ');
//   const cookie = cookies.find(row => row.startsWith(name + '='));
//   if (!cookie) return null;
//   const indexOfEqual = cookie.indexOf('=');
//   const value = cookie.substring(indexOfEqual + 1); 
//   return value;
// }

export const axiosInstance = axios.create({
  baseURL: apiURL,
  headers: {
    'Content-Type': 'application/json',
  }
});

axiosInstance.interceptors.request.use(
  async config => {
    const path = window.location.pathname;
    if (path.startsWith('/quick-connect')) {
      const xApiKey = await getXApiKey();
      if (xApiKey) {
        config.headers['x-api-key'] = xApiKey;
        delete config.headers['Authorization'];
      }
    } else if (path.startsWith('/chat')) {
      const jwtToken = _jwtToken || await getJwtToken();
      if (jwtToken) {
        config.headers['Authorization'] = jwtToken;
        delete config.headers['x-api-key'];
      }
    }

    return config;
  },
  error => Promise.reject(error)
);

export const jobseekerAxiosInstance = axios.create({
  baseURL: jobseekerApiURL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': connectionsXApiKey
  }
});

export const coreApiAxiosInstance = axios.create({
  baseURL: coreApiURL,
  headers: {
    'Content-Type': 'application/json'
  }
})

const axiosInstances = {
  axiosInstance,
  coreApiAxiosInstance,
  jobseekerAxiosInstance
};

export default axiosInstances;
